__turbopack_context__.v({
  "contentWrapper": "ShareModal-module__JvCpdG__contentWrapper",
  "footer": "ShareModal-module__JvCpdG__footer",
  "shareList": "ShareModal-module__JvCpdG__shareList",
  "title": "ShareModal-module__JvCpdG__title",
});
